import type { MaybeRef } from "vue"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"

export async function validateGuestAccessToken(token?: string, eventVaultId?: number, albumId?: number) {
  if (!token || !eventVaultId) {
    throw new Error("Missing token or eventVaultId when attempting to validate guest access token. Please ensure `token` and `eventVaultId` are provided.")
  }

  const response = await axios.get(`api/guest/${eventVaultId}/validateaccess/${token}`, {
    params: {
      album: albumId,
    },
  })

  return response.data
}

export function useValidateGuestAccessToken(token?: MaybeRef<string | undefined>, eventVaultId?: MaybeRef<number | undefined>, albumId?: MaybeRef<number | undefined>) {
  const tokenValue = toValue(token)
  const eventVaultIdValue = toValue(eventVaultId)
  const albumIdValue = toValue(albumId)

  return useQuery({
    queryKey: ["validateGuestAccessToken", token, eventVaultId, albumId],
    queryFn: () => validateGuestAccessToken(tokenValue, eventVaultIdValue, albumIdValue),
    enabled: !!tokenValue && !!eventVaultIdValue,
  })
}
